import React from 'react'
import MachineAssigning from './MachineAssigning'
import { ClientSideTable } from 'Presentation/Components/Table'
import { KTSVG } from '_metronic/helpers'

interface Props {
  formType: 'add' | 'edit'
  machineData: any[]
  machines: any[]
  MACHINE_TABLE_CONFIGS: any[]
  machineFormState: any
  isSubmittingAssignMachine: boolean
  isOpenAssignMachineModal: boolean
  onChangeMachineFormState: (name: string, value: any) => void
  onStartAssignMachine: () => void
  onStopAssignMachine: () => void
  onSubmitAssignMachine: () => void
}

const ProjectMachineView: React.FC<Props> = ({
  formType,
  machineData,
  machines,
  MACHINE_TABLE_CONFIGS,
  machineFormState,
  isSubmittingAssignMachine,
  isOpenAssignMachineModal,
  onChangeMachineFormState,
  onStartAssignMachine,
  onStopAssignMachine,
  onSubmitAssignMachine,
}) => {
  return (
    <React.Fragment>
      <MachineAssigning
        formType={formType}
        isSubmitting={isSubmittingAssignMachine}
        isOpen={isOpenAssignMachineModal}
        options={machineData}
        formState={machineFormState}
        onChangeFormState={onChangeMachineFormState}
        handleClose={onStopAssignMachine}
        onSubmit={onSubmitAssignMachine}
      />

      <div className='card'>
        <div className='card-header'>
          <div className='card-title'></div>
          <div className='card-toolbar'>
            <button
              className='btn btn-sm btn-primary me-2 cursor-pointer'
              onClick={onStartAssignMachine}>
              <KTSVG
                path='/media/icons/duotune/arrows/arr075.svg'
                svgClassName='svg-icon-1x svg-primary'
              />
              <span>เพิ่มเครื่องจักร</span>
            </button>
          </div>
        </div>

        <div className='card-body px-0'>
          <ClientSideTable
            isGrey
            pagination
            columns={MACHINE_TABLE_CONFIGS}
            data={machines}
            items_per_page={10}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectMachineView
